export const productionAssetTypes = [
  {
    id: 14,
    name: 'Excavator',
    symbol: 'EX',
  },
  {
    id: 17,
    name: 'Surface Dumper',
    symbol: 'SD',
  },
  {
    id: 8,
    name: 'Load Haul Dump',
    symbol: 'LHD',
  },
  {
    id: 20,
    name: 'Loader',
    symbol: 'LDR',
  },
  {
    id: 46,
    name: 'Underground Dumper',
    symbol: 'UD',
  },
  {
    id: 41,
    name: 'Highway Truck',
    symbol: 'HT',
  },
]

export const drillingAssetTypes = [
  {
    id: 29,
    name: 'Drill Rig',
    symbol: 'DR',
  },
  {
    id: 24,
    name: 'Large Hole Auger',
    symbol: 'LHA',
  },
  {
    id: 25,
    name: 'Roof Bolter',
    symbol: 'RB',
  },
]

export const auxiliaryAssetTypes = [
  {
    id: 7,
    name: 'Scaler',
    symbol: 'SLR',
  },
  {
    id: 38,
    name: 'Dozer',
    symbol: 'DZR',
  },
  {
    id: 68,
    name: 'Plant',
    symbol: 'PLT',
  },

  {
    id: 18,
    name: 'Locomotive',
    symbol: 'Loco',
  },
  {
    id: 53,
    name: 'Fuel Tank Truck',
    symbol: 'FTT',
  },
]
